const article = {
  slug: 'payment-plans',
  title: 'Payment plans',
  section: 'Money',
  body: `
# Payment plans

For a delinquent tenant who commits to catching up, set up a **payment
plan** from the rental row.

- Split the outstanding balance into scheduled installments.
- Record installments as they arrive; the plan tracks progress.
- The plan documents the arrangement - useful for lien-timeline
  decisions and dispute records.

> A plan does not pause late fees or the delinquency clock by itself -
> waive fees deliberately if that's part of the arrangement.
`,
};

export default article;
